﻿import {withGrayTransparency} from "../../../../hocs/withGrayTransparency";
import {CardItemValue} from "../CardItemValue";

export const CardItemValueWithGray = withGrayTransparency(CardItemValue);
